<div class="data-analysis-wrap">
  <h1>Glucose Data Analysis</h1>
  <p class="intro">
    Upload a CSV containing member IDs, choose a date range, then submit to run the analysis request.
  </p>

  <div class="analysis-card">
    <div class="field-block">
      <label class="field-label">Member list (CSV)</label>
      <div
        class="upload-box"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        [class.upload-box-active]="dragActive"
      >
        <input
          #fileInput
          type="file"
          accept=".csv,text/csv"
          class="file-input"
          (change)="onFileSelected($event)"
        />
        <p class="upload-hint" *ngIf="!fileName">Drop a CSV here or <button type="button" class="linkish" (click)="fileInput.click()">browse</button></p>
        <p class="file-name" *ngIf="fileName">{{ fileName }}</p>
        <p class="parse-meta" *ngIf="memberIds.length">
          {{ memberIds.length }} unique member ID<span *ngIf="memberIds.length !== 1">s</span> found
        </p>
        <p class="parse-error" *ngIf="csvError">{{ csvError }}</p>
      </div>
    </div>

    <div class="field-block">
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Date range</mat-label>
        <mat-date-range-input [rangePicker]="rangePicker" [formGroup]="range">
          <input matStartDate formControlName="start" placeholder="Start date" />
          <input matEndDate formControlName="end" placeholder="End date" />
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
        <mat-date-range-picker #rangePicker></mat-date-range-picker>
      </mat-form-field>
    </div>

    <div class="actions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="submit-btn"
        (click)="submit()"
        [disabled]="submitting || !canSubmit"
      >
        <mat-spinner *ngIf="submitting" diameter="20"></mat-spinner>
        <span *ngIf="!submitting">Submit</span>
      </button>
    </div>
  </div>

  <div class="results-card" *ngIf="analysisResult as r">
    <div class="results-header">
      <h2 class="results-title">Results</h2>
      <button
        mat-stroked-button
        color="primary"
        type="button"
        class="download-csv-btn"
        (click)="downloadCurrentResultCsv()"
      >
        Download CSV
      </button>
    </div>
    <p class="results-hint">Exported file columns: <strong>Name</strong>, <strong>MemberId</strong>, <strong>TIR</strong>, <strong>veryHigh</strong>, <strong>high</strong>, <strong>low</strong>, <strong>veryLow</strong>.</p>
    <p class="results-period">
      <span class="results-label">Period</span>
      {{ r.startDate | date : 'MMMM d, y' }} — {{ r.endDate | date : 'MMMM d, y' }}
    </p>

    <div class="table-scroll">
      <table class="results-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Member ID</th>
            <th>TIR (%)</th>
            <th>Very high (%)</th>
            <th>High (%)</th>
            <th>Low (%)</th>
            <th>Very low (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of r.members">
            <td>{{ row.name || '-' }}</td>
            <td class="cell-id">{{ row.memberId }}</td>
            <td>{{ row.range.inRange }}</td>
            <td>{{ row.range.veryHigh }}</td>
            <td>{{ row.range.high }}</td>
            <td>{{ row.range.low }}</td>
            <td>{{ row.range.veryLow }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
